import {
  CREATE_USER_OPTION,
  DELETE_USER_OPTION,
  EDIT_USER_OPTION,
  RECEIVE_USER_OPTIONS,
  REQUEST_USER_OPTION,
  REQUEST_USER_OPTIONS_FOR_USER,
} from '@sophocles/entities/UserOption/userOptionActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_USER_OPTIONS: // Read
      return state.merge(action.userOptions);
    case DELETE_USER_OPTION: // Delete
      return state.delete(action.userOption.toString());
    case EDIT_USER_OPTION: // Update
    case CREATE_USER_OPTION: // Create
    case REQUEST_USER_OPTION:
    case REQUEST_USER_OPTIONS_FOR_USER:
    default:
      return state;
  }
}

export function userOptionReducer(state = Map(), action) {
  switch (action.type) {
    case CREATE_USER_OPTION:
    case DELETE_USER_OPTION:
    case RECEIVE_USER_OPTIONS:
    case EDIT_USER_OPTION:
    case REQUEST_USER_OPTION:
    case REQUEST_USER_OPTIONS_FOR_USER:
      return getState(state, action);
    default:
      return state;
  }
}
